export const updateSpecificInfoEndpoint = '/berths/booking/update-specific-info' as const
